import { render, staticRenderFns } from "./myDialog.vue?vue&type=template&id=1fea4a2e&scoped=true&"
import script from "./myDialog.vue?vue&type=script&lang=js&"
export * from "./myDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea4a2e",
  null
  
)

export default component.exports